// @flow
import React from 'react';
import styled from 'styled-components';

const propTypes = {};
const defaultProps = {};

const StyledGrid = styled.ul`
  background: white;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0 0.875rem 0.875rem 0.875rem;
  margin: 0;
`;

const DayGrid = (props:Object) => {
  return (
    <StyledGrid>
      {props.children}
    </StyledGrid>
  );
}

DayGrid.propTypes = propTypes;
DayGrid.defaultProps = defaultProps;

export default DayGrid;



// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/DayGrid.js